/**
 * ScrollToTop — Global route-level scroll restoration
 * 
 * FOUNDER DIRECTIVE: Every route transition enters at scrollY = 0
 * unless explicitly deep-linked with hash anchors.
 * Browser back preserves prior scroll position (native behavior).
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Same route + anchor = scroll to anchor
    if (hash) return;

    // New route = top of page
    if (prevPathname.current !== pathname) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }

    prevPathname.current = pathname;
  }, [pathname, hash]);

  return null;
}
